import { User } from './../../domain/model/user';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface DeleteUserRepository {
    (id: number): Promise<User>
}

const deleteUserRepository = (axios: AxiosInstance): DeleteUserRepository => async (id: number) => {
    try {
        const response: AxiosResponse = await axios.delete(`/account/${id}`)

        const user: User = response.data
        return user
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default deleteUserRepository